var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopSm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 492,
    height: 481,
    viewBox: "0 0 492 481",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_15475)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.5607 485.285C73.2266 480.71 71.0117 473.826 67.5374 465.721C65.7338 461.513 64.2901 458.607 60.5142 451.173C47.3425 425.237 46.1366 423.625 46.9692 420.069C48.7458 412.482 57.2828 406.817 64.5274 402.01C71.1646 397.605 74.0075 397.53 75.5639 393.983C78.0561 388.303 72.5765 384.37 69.0424 371.91C66.1695 361.781 66.5885 353.09 67.0357 343.817C67.4896 334.404 68.9939 326.856 69.5439 324.252C72.1157 312.075 74.6004 309.592 74.5607 301.176C74.5246 293.533 72.4378 287.585 71.5507 285.123C69.7613 280.155 68.2897 278.553 61.0157 265.056C58.4663 260.326 57.1919 257.961 56.5007 256.528C53.7542 250.833 48.2013 239.042 47.4709 223.92C47.1738 217.768 47.0252 214.692 48.4742 210.877C50.2792 206.125 52.9752 204.178 58.5074 196.329C61.7725 191.697 63.39 189.37 64.0257 187.801C67.6425 178.871 64.0783 169.505 63.0224 166.731C58.2548 154.203 50.7199 154.076 47.9727 144.658C46.1121 138.279 48.1157 133.359 52.4874 121.581C67.5877 80.9027 68.3945 73.0428 75.0622 71.9169C83.0579 70.5668 94.851 79.6828 97.1352 81.4485C101.671 84.9547 103.644 87.7993 107.67 87.9701C114.013 88.2392 119.069 81.6009 120.713 79.4419C128.985 68.5818 124.359 61.1 129.743 51.3488C135.648 40.6563 148.071 37.2288 162.351 33.2891C172.302 30.5438 187.06 26.4722 202.986 31.7841C219.857 37.4114 224.117 48.9261 237.099 47.3355C241.255 46.8263 245.388 44.4877 253.654 39.8107C266.241 32.6883 268.565 28.2303 276.228 26.7675C281.913 25.6822 285.111 27.281 294.288 29.7775C311.827 34.5483 309.462 31.242 343.451 37.804C343.451 37.804 354.422 39.9222 369.035 42.319C376.806 43.5935 378.28 43.745 380.072 43.8239C391.827 44.3414 393.719 40.6935 405.155 39.8107C410.372 39.4079 408.18 40.3059 433.75 43.8239C435.919 44.1224 439.146 44.5577 442.278 46.8339C446.446 49.8629 445.796 52.7711 448.799 55.8638C452.329 59.4984 456.783 59.1446 472.712 60.0443C472.712 60.0443 480.233 60.4691 487.427 61.0476C497.975 61.8957 507.19 159.611 508.163 506.188",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5607 485.285C73.2266 480.71 71.0117 473.826 67.5374 465.721C65.7338 461.513 64.2901 458.607 60.5142 451.173C47.3425 425.237 46.1366 423.625 46.9692 420.069C48.7458 412.482 57.2828 406.817 64.5274 402.01C71.1646 397.605 74.0075 397.53 75.5639 393.983C78.0561 388.303 72.5765 384.37 69.0424 371.91C66.1695 361.781 66.5885 353.09 67.0357 343.817C67.4896 334.404 68.9939 326.856 69.5439 324.252C72.1157 312.075 74.6004 309.592 74.5607 301.176C74.5246 293.533 72.4378 287.585 71.5507 285.123C69.7613 280.155 68.2897 278.553 61.0157 265.056C58.4663 260.326 57.1919 257.961 56.5007 256.528C53.7542 250.833 48.2013 239.042 47.4709 223.92C47.1738 217.768 47.0252 214.692 48.4742 210.877C50.2792 206.125 52.9752 204.178 58.5074 196.329C61.7725 191.697 63.39 189.37 64.0257 187.801C67.6425 178.871 64.0783 169.505 63.0224 166.731C58.2548 154.203 50.7199 154.076 47.9727 144.658C46.1121 138.279 48.1157 133.359 52.4874 121.581C67.5877 80.9027 68.3945 73.0428 75.0622 71.9169C83.0579 70.5668 94.851 79.6828 97.1352 81.4485C101.671 84.9547 103.644 87.7993 107.67 87.9701C114.013 88.2392 119.069 81.6009 120.713 79.4419C128.985 68.5818 124.359 61.1 129.743 51.3488C135.648 40.6563 148.071 37.2288 162.351 33.2891C172.302 30.5438 187.06 26.4722 202.986 31.7841C219.857 37.4114 224.117 48.9261 237.099 47.3355C241.255 46.8263 245.388 44.4877 253.654 39.8107C266.241 32.6883 268.565 28.2303 276.228 26.7675C281.913 25.6822 285.11 27.281 294.288 29.7775C311.827 34.5483 309.462 31.242 343.451 37.804C343.451 37.804 354.422 39.9222 369.035 42.319C376.806 43.5935 378.28 43.745 380.072 43.8239C391.827 44.3414 393.719 40.6935 405.155 39.8107C410.372 39.4079 408.18 40.3059 433.75 43.8239C435.919 44.1224 439.146 44.5577 442.278 46.8339C446.446 49.8629 445.796 52.7711 448.799 55.8638C452.329 59.4984 456.783 59.1446 472.712 60.0443C472.712 60.0443 480.233 60.4691 487.428 61.0476C497.975 61.8957 507.19 159.611 508.163 506.188",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M482.74 13.2236H5.82812V469.735H482.74V13.2236Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.832 488.129C106.545 486.853 105.744 479.214 100.812 470.738C95.9392 462.365 92.1223 461.917 90.1096 455.354C87.5107 446.88 91.0919 438.555 92.7852 434.618C95.5379 428.219 97.103 429.197 104.156 417.228C108.915 409.151 110.222 405.279 110.845 403.181C112.507 397.583 112.718 393.109 112.852 389.803C113.147 382.514 113.53 373.047 108.838 364.386C105.036 357.366 102.454 359.285 96.1296 351.008C93.1345 347.089 84.8553 336.255 86.0963 323.584C86.5449 319.004 88.2153 314.411 91.4475 305.525C93.9884 298.538 94.5056 298.671 94.7919 296.16C95.913 286.332 88.1103 283.269 89.4407 275.425C90.3606 270.003 94.2334 270.612 98.1363 261.378C99.5257 258.091 101.208 254.112 100.812 249.338C100.503 245.619 99.0206 242.478 92.7851 234.623C81.9143 220.929 78.7581 220.824 76.0633 213.888C75.1742 211.599 72.465 204.626 74.7254 197.166C77.3685 188.442 84.2485 187.497 84.0898 181.781C83.8895 174.573 72.8554 172.865 72.7189 165.059C72.6597 161.678 74.7218 161.516 78.0698 153.02C80.478 146.909 81.682 143.853 81.4142 140.98C80.5437 131.64 68.8919 129.5 68.7054 121.582C68.6051 117.322 71.8611 112.955 75.3942 110.88C86.4884 104.364 98.8785 121.286 115.527 116.9C124.401 114.563 129.808 107.404 134.256 101.516C142.92 90.0461 147.237 74.0311 148.302 70.0784C150.602 61.5464 150.394 58.5342 152.984 57.3696C161.241 53.6577 177.877 77.7307 182.415 74.7605C184.16 73.6187 181.99 69.8717 182.415 62.0518C182.661 57.5342 183.254 46.615 190.442 41.3165C197.314 36.2505 208.585 37.5237 215.191 42.6542C220.515 46.7905 218.709 50.2499 227.23 63.3896C234.793 75.0506 238.6 76.0021 240.608 76.0983C244.077 76.2645 246.752 74.0982 249.972 71.4161C259.194 63.7351 257.275 58.653 263.35 54.0252C267.14 51.1379 268.308 52.7957 292.781 50.0119C299.069 49.2966 302.048 48.8395 307.496 48.6742C322.726 48.2119 326.355 50.967 327.562 52.0186C331.428 55.3864 330.056 58.3594 333.582 60.7141C338.514 64.0067 343.449 59.6964 352.98 58.7074C367.931 57.1561 369.253 66.3637 384.417 64.7273C391.522 63.9607 396.315 61.3911 403.146 64.0584C407.368 65.707 406.769 67.1696 410.504 68.7406C419.683 72.6012 425.956 64.885 438.597 66.0651C442.318 66.4125 439.782 66.8951 452.643 70.7472C467.12 75.0831 473.65 75.465 479.398 74.7605C483.463 74.2624 485.151 73.4645 486.087 73.4228C504.742 72.5907 641.169 353.114 502.14 494.149C369.348 628.857 111.383 508.364 106.832 488.129Z",
    fill: "#9E1F63",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.918 484.116C239.948 477.733 247.697 467.414 248.633 454.016C249.575 440.549 242.716 437.092 244.62 427.261C247.913 410.263 269.975 412.585 288.097 389.804C302.027 372.293 294.146 364.442 308.833 349.671C315.97 342.492 317.017 345.166 349.634 326.929C366.019 317.768 370.77 314.29 381.741 310.876C383.562 310.309 387.435 308.589 392.85 307.68C399.54 306.557 409.391 304.903 414.516 309.538C421.351 315.719 417.282 330.87 414.516 341.644C410.923 355.642 405.493 363.102 407.827 365.055C410.494 367.288 416.805 356.887 430.569 355.022C441.143 353.589 448.259 358.258 455.317 353.015C456.422 352.195 457.615 350.685 460 347.664C467.395 338.299 467.415 334.451 471.371 331.611C471.371 331.611 477.618 327.126 487.424 330.273C496.256 333.108 503.517 360.088 486.086 487.46",
    fill: "#9E1F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.918 484.116C239.948 477.733 247.697 467.414 248.633 454.016C249.575 440.549 242.716 437.092 244.62 427.261C247.913 410.263 269.975 412.585 288.097 389.804C302.027 372.293 294.146 364.442 308.833 349.671C315.97 342.492 317.017 345.166 349.634 326.929C366.019 317.768 370.77 314.29 381.741 310.876C383.562 310.309 387.435 308.589 392.85 307.68C399.54 306.557 409.391 304.903 414.516 309.538C421.351 315.719 417.282 330.87 414.516 341.644C410.923 355.642 405.493 363.102 407.827 365.055C410.494 367.288 416.805 356.887 430.569 355.022C441.143 353.589 448.259 358.258 455.317 353.015C456.422 352.195 457.615 350.685 460 347.664C467.395 338.299 467.415 334.451 471.371 331.611C471.371 331.611 477.618 327.126 487.424 330.273C496.256 333.108 503.517 360.088 486.086 487.46",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.637 484.784C250.164 482.135 249.187 474.585 253.536 467.393C255.933 463.428 258.965 461.2 260.893 459.813C267.257 455.233 273.69 454.31 277.615 453.792C282.356 453.168 285.73 453.491 291.216 454.015C299.738 454.831 304.93 455.327 310.836 458.029C318.899 461.717 318.333 464.956 326.221 467.616C331.47 469.386 335.997 469.393 340.044 469.4C347.217 469.411 351.066 469.417 354.314 466.947C358.299 463.917 356.719 460.703 360.557 453.124C361.964 450.344 366.288 441.804 374.826 437.516C380.222 434.807 382.148 436.382 390.21 432.388C393.948 430.537 394.388 429.775 398.46 427.929C402.031 426.31 405.902 424.555 411.169 423.916C413.796 423.597 419.815 422.934 426.33 425.477C432.383 427.839 432.975 430.669 437.032 430.605C439.362 430.568 439.894 429.622 447.065 425.477C452.538 422.313 455.274 420.731 458.882 419.457C463.147 417.951 462.316 419.024 469.584 417.004C474.975 415.506 477.64 414.302 482.293 414.329C484.399 414.341 486.362 414.602 486.975 414.774C496.16 417.362 488.085 480.464 487.198 487.237",
    fill: "#9E1F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.637 484.784C250.164 482.135 249.187 474.585 253.536 467.393C255.933 463.428 258.965 461.2 260.893 459.813C267.257 455.233 273.69 454.31 277.615 453.793C282.356 453.168 285.73 453.491 291.216 454.015C299.738 454.831 304.93 455.327 310.836 458.029C318.899 461.717 318.333 464.956 326.221 467.616C331.47 469.386 335.997 469.393 340.044 469.4C347.217 469.411 351.066 469.417 354.314 466.947C358.299 463.917 356.719 460.703 360.557 453.124C361.964 450.344 366.288 441.804 374.826 437.516C380.222 434.807 382.148 436.382 390.21 432.388C393.948 430.537 394.388 429.775 398.46 427.929C402.031 426.31 405.902 424.555 411.169 423.916C413.796 423.597 419.815 422.934 426.33 425.477C432.383 427.839 432.975 430.669 437.032 430.605C439.362 430.568 439.894 429.622 447.065 425.477C452.538 422.313 455.274 420.731 458.882 419.457C463.147 417.951 462.316 419.024 469.584 417.004C474.975 415.506 477.64 414.302 482.293 414.329C484.399 414.341 486.362 414.602 486.975 414.774C496.16 417.362 488.085 480.464 487.198 487.237",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.863 484.116C113.808 473.119 111.22 464.381 109.506 458.699C104.901 443.432 102.967 438.152 105.492 431.943C107.226 427.683 110.215 425.313 116.195 420.572C116.195 420.572 121.544 416.331 140.274 407.195C145.209 403.859 148.005 400.368 149.638 397.83C152.269 393.743 152.131 391.74 155.658 385.79C158.515 380.973 159.943 378.564 162.347 377.095C168.042 373.615 173.033 377.287 176.394 374.419C180.519 370.899 177.73 361.326 177.063 359.035C171.127 338.665 154.874 338.169 150.976 321.578C148.137 309.49 154.011 298.036 155.658 294.823C159.399 287.528 161.843 287.949 168.367 279.438C172.438 274.129 187.259 254.796 182.414 234.623C181.261 229.823 180.372 226.124 177.063 223.252C168.806 216.088 157.278 224.311 138.936 217.901C135.085 216.556 131.16 214.644 128.234 213.219C119.336 208.886 114.887 206.719 114.188 204.524C111.771 196.932 129.25 179.074 148.97 177.1C156.654 176.33 158.533 178.588 173.718 177.769C182.59 177.29 189.161 176.13 195.122 171.749C196.779 170.531 199.595 168.461 201.142 165.729C209.492 150.979 174.553 128.086 179.738 102.854C181.594 93.8207 188.408 85.3923 196.46 82.7874C207.676 79.159 219.763 87.325 227.897 92.8206C227.897 92.8206 231.249 95.0851 248.633 110.88C257.156 111.317 268.674 110.385 277.395 102.854C280.942 99.7899 280.655 98.5464 284.752 94.1584C297.84 80.1438 316.061 76.4611 316.19 76.7675C316.295 77.0157 305.016 81.0582 305.488 82.7874C305.93 84.4096 316.078 81.6633 333.581 80.7808C350.62 79.9216 352.092 81.965 365.018 80.1119C373.349 78.9174 374.916 77.7563 384.416 76.7675C395.879 75.5744 401.611 74.9778 406.489 77.4363C417.732 83.1026 420.847 100.034 420.535 100.178C420.307 100.284 416.71 92.063 416.522 92.1517C416.275 92.2688 419.21 108.147 430.569 114.894C432.43 116 431.807 115.25 449.966 120.245C462.521 123.698 459.121 123.04 464.013 124.258C471.706 126.174 474.53 126.412 478.728 128.94C481.696 130.728 483.715 132.674 486.086 134.96C486.086 134.96 490.598 139.312 494.112 144.324C525.147 188.6 506.152 303.518 506.152 303.518C498.684 348.701 492.248 411.7 496.119 492.811",
    fill: "#9E1F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.863 484.116C113.808 473.119 111.22 464.381 109.506 458.699C104.901 443.432 102.967 438.152 105.492 431.943C107.226 427.683 110.215 425.313 116.195 420.572C116.195 420.572 121.544 416.331 140.274 407.195C145.209 403.859 148.005 400.368 149.638 397.83C152.269 393.743 152.131 391.74 155.658 385.79C158.515 380.973 159.943 378.564 162.347 377.095C168.042 373.615 173.033 377.287 176.394 374.419C180.519 370.899 177.73 361.326 177.063 359.035C171.127 338.665 154.874 338.169 150.976 321.578C148.137 309.49 154.011 298.036 155.658 294.823C159.399 287.528 161.843 287.949 168.367 279.438C172.438 274.129 187.259 254.796 182.414 234.623C181.261 229.823 180.372 226.124 177.063 223.252C168.806 216.088 157.278 224.311 138.936 217.901C135.085 216.556 131.16 214.644 128.234 213.219C119.336 208.886 114.887 206.719 114.188 204.524C111.771 196.932 129.25 179.074 148.97 177.1C156.654 176.33 158.533 178.588 173.718 177.769C182.59 177.29 189.161 176.13 195.122 171.749C196.779 170.531 199.595 168.461 201.142 165.729C209.492 150.979 174.553 128.086 179.738 102.854C181.594 93.8207 188.408 85.3923 196.46 82.7874C207.676 79.159 219.763 87.325 227.897 92.8206C227.897 92.8206 231.249 95.0851 248.633 110.88C257.156 111.317 268.674 110.385 277.395 102.854C280.942 99.7899 280.655 98.5464 284.752 94.1584C297.84 80.1438 316.06 76.4611 316.19 76.7675C316.295 77.0157 305.016 81.0582 305.488 82.7874C305.93 84.4096 316.078 81.6633 333.581 80.7808C350.62 79.9216 352.092 81.965 365.018 80.1119C373.349 78.9174 374.916 77.7563 384.416 76.7675C395.879 75.5744 401.611 74.9778 406.489 77.4363C417.732 83.1026 420.847 100.034 420.535 100.178C420.307 100.284 416.71 92.063 416.522 92.1517C416.275 92.2688 419.21 108.147 430.569 114.894C432.43 116 431.807 115.25 449.966 120.245C462.521 123.698 459.121 123.04 464.013 124.258C471.706 126.174 474.53 126.412 478.728 128.94C481.696 130.728 483.715 132.674 486.086 134.96C486.086 134.96 490.598 139.312 494.112 144.324C525.147 188.6 506.152 303.518 506.152 303.518C498.684 348.701 492.248 411.7 496.119 492.811",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.404 484.785C184.572 476.882 183.312 472.6 182.41 470.738C181.194 468.225 179.127 467.016 169.033 462.043C157.424 456.325 154.841 455.305 154.986 454.016C155.302 451.216 167.98 451.714 180.404 444.652C182.025 443.73 184.513 442.185 186.424 439.301C189.078 435.294 189.052 431.067 189.099 428.599C189.317 417.066 191.585 419.486 192.443 403.85C193.005 393.627 191.983 393.539 192.443 379.102C192.709 370.778 192.86 366.532 193.781 362.38C196.026 352.259 200.252 345.901 203.145 341.644C206.738 336.357 208.588 333.712 211.172 333.618C216.062 333.439 221.268 341.887 223.212 349.671C226.946 364.62 217.232 371.424 219.868 391.141C220.612 396.707 221.957 400.437 223.212 403.85C225.291 409.503 228.639 418.606 232.576 418.566C235.252 418.538 236.519 414.306 240.603 406.526C247.093 394.161 248.645 395.798 254.649 384.453C261.398 371.702 264.781 365.309 262.676 358.366C261.778 355.404 260.943 355.844 252.643 343.651C248.755 337.94 246.811 335.084 245.285 332.28C241.681 325.657 237.575 318.112 237.927 308.869C238.262 300.08 242.478 293.712 245.285 289.472C252.72 278.24 257.825 280.305 263.345 270.743C267.609 263.356 269.84 252.983 268.027 243.319C266.552 235.456 263.502 233.927 264.683 229.272C266.181 223.366 271.943 222.473 283.411 214.557C292.514 208.274 298.516 202.188 302.809 197.835C307.568 193.009 311.333 188.151 318.862 178.437C327.999 166.649 332.641 160.613 336.253 153.689C338.426 149.523 341.839 142.886 344.279 133.622C345.822 127.767 346.952 120.952 347.624 116.9C349.744 104.118 349.454 100.704 352.306 98.8405C357.072 95.7267 365.216 100.465 367.021 101.516C381.784 110.106 386.976 129.618 385.75 130.278C384.781 130.8 378.199 120.393 378.392 120.245C378.588 120.094 386.266 130.029 401.803 149.007C406.767 155.069 406.973 155.26 411.168 160.377C433.649 187.802 444.22 202.567 445.281 201.848C446.206 201.221 439.741 188.924 439.261 189.139C438.626 189.424 445.806 212.759 453.307 212.55C456.621 212.458 456.859 207.856 463.34 203.186C468.725 199.306 477.904 195.75 482.738 199.173C484.918 200.716 486.119 203.613 486.082 215.895C486.036 231.138 484.155 236.349 484.076 244.656C483.931 259.779 490.002 259.282 491.433 274.756C493.539 297.521 481.284 308.168 488.089 318.902C492.642 326.084 501.144 325.721 506.149 328.267C520.469 335.549 523.261 374.76 490.764 491.474",
    fill: "#9E1F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.404 484.785C184.572 476.882 183.312 472.6 182.41 470.738C181.194 468.225 179.127 467.016 169.033 462.043C157.424 456.325 154.841 455.305 154.986 454.016C155.302 451.216 167.98 451.714 180.404 444.652C182.025 443.73 184.513 442.185 186.424 439.301C189.078 435.294 189.052 431.067 189.099 428.599C189.317 417.066 191.585 419.486 192.443 403.85C193.005 393.627 191.983 393.539 192.443 379.102C192.709 370.778 192.86 366.532 193.781 362.38C196.026 352.259 200.252 345.901 203.145 341.644C206.738 336.357 208.588 333.712 211.172 333.618C216.062 333.439 221.268 341.887 223.212 349.671C226.946 364.62 217.232 371.424 219.868 391.141C220.612 396.707 221.957 400.437 223.212 403.85C225.291 409.503 228.639 418.606 232.576 418.566C235.252 418.538 236.519 414.306 240.603 406.526C247.093 394.161 248.645 395.798 254.649 384.453C261.398 371.702 264.781 365.309 262.676 358.366C261.778 355.404 260.943 355.844 252.643 343.651C248.755 337.94 246.811 335.084 245.285 332.28C241.681 325.657 237.575 318.112 237.927 308.869C238.262 300.08 242.478 293.712 245.285 289.472C252.72 278.24 257.825 280.305 263.345 270.743C267.609 263.356 269.84 252.983 268.027 243.319C266.552 235.456 263.502 233.927 264.683 229.272C266.181 223.366 271.943 222.473 283.411 214.557C292.514 208.274 298.516 202.188 302.809 197.835C307.568 193.009 311.333 188.151 318.862 178.437C327.999 166.649 332.641 160.613 336.253 153.689C338.426 149.523 341.839 142.886 344.279 133.622C345.822 127.767 346.952 120.952 347.624 116.9C349.744 104.118 349.454 100.704 352.306 98.8405C357.072 95.7267 365.216 100.465 367.022 101.516C381.784 110.106 386.976 129.618 385.75 130.278C384.781 130.8 378.199 120.393 378.392 120.245C378.588 120.094 386.266 130.029 401.803 149.007C406.767 155.069 406.973 155.26 411.168 160.377C433.649 187.802 444.22 202.567 445.281 201.848C446.206 201.221 439.741 188.924 439.261 189.139C438.626 189.424 445.806 212.759 453.307 212.55C456.621 212.458 456.859 207.856 463.34 203.186C468.725 199.306 477.904 195.75 482.738 199.173C484.918 200.716 486.119 203.613 486.082 215.895C486.036 231.138 484.155 236.349 484.076 244.656C483.931 259.779 490.002 259.282 491.433 274.756C493.539 297.521 481.284 308.168 488.089 318.902C492.642 326.084 501.144 325.721 506.149 328.267C520.469 335.549 523.261 374.76 490.764 491.474",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M601.469 557.048V-10.7539L482.742 -10.7539V557.048H601.469Z",
    fill: "#6C3950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.027 75.7324H179.406V182.785H216.027V75.7324Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.497 273.147H90.1328V309.706H207.497V273.147Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.5 328.768H98.6328V365.89H209.5V328.768Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.925 390.473H87.0977V414.329H185.925V390.473Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.925 455.188H87.0977V469.736H185.925V455.188Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.504 365.891H185.926V469.734H209.504V365.891Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.395 215.393H101.645V245.994H177.395V215.393Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.03 205.359H177.402V225.426H216.03V205.359Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.982 153.688H34.4219V168.237H154.982V153.688Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.073 113.555H83.5898V136.631H154.073V113.555Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.875 85.4619H129.742V104.525H169.875V85.4619Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1306 52.3525H34.4219V68.9073H90.1306V52.3525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.657 55.8643H108.164V75.7317H146.657V55.8643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.395 34.2939H111.176V48.8421H177.395V34.2939Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.754 68.4062H249.133V88.4727H436.754V68.4062Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.891 71.416H452.805V104.526H478.891V71.416Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.698 108.54H249.133V168.238H268.698V108.54Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.287 136.632H268.699V158.203H295.287V136.632Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.491 104.526H327.395V147.418H356.491V104.526Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.151 108.54H383.078V143.656H405.151V108.54Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.335 143.655H440.773V234.958H459.335V143.655Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.77 116.064H425.219V147.418H440.77V116.064Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.82 116.064H440.773V136.633H454.82V116.064Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.194 189.308H244.285V250.009H267.194V189.308Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.046 193.376H266.242V213.888H274.046V193.376Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.868 185.35H274.051V218.125H285.868V185.35Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.174 173.086H295.285V213.888H312.174V173.086Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.665 154.134H318.199V181.335H335.665V154.134Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.247 273.147H244.285V319.237H266.247V273.147Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.378 268.736H255.266V279.104H272.378V268.736Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.928 304.855H281.992V319.236H326.928V304.855Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.193 319.236H285.863V327.597H318.193V319.236Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.092 323.418H244.285V406.526H253.092V323.418Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.677 346.326H253.09V393.371H262.677V346.326Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.313 285.458H279.961V300.842H319.313V285.458Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.394 246.218H272.379V263.386H310.394V246.218Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.471 218.905H334.746V241.48H352.471V218.905Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.518 222.249H362.344V250.008H381.518V222.249Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.548 246.218H323.996V263.386H356.548V246.218Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.246 263.385H323.996V278.658H332.246V263.385Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.617 278.658H323.996V290.81H343.617V278.658Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.391 171.414H413.512V191.313H427.391V171.414Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.996 176.933H427.395V191.314H432.996V176.933Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.26 39.7549H373.488V58.595H405.26V39.7549Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.239 39.7549H414.398V58.595H433.239V39.7549Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.392 34.6279H240.438V55.8649H327.392V34.6279Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.83 35.6553H331.598V60.046H358.83V35.6553Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.683 39.4775H192.613V67.4033H213.683V39.4775Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.424 39.4775H176.227V67.4033H185.424V39.4775Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.704 39.4775H213.688V54.3601H218.704V39.4775Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.616 39.4775H185.426V58.3734H192.616V39.4775Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1341 85.4619H52.6523V108.204H90.1341V85.4619Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1971 108.874H34.4219V132.452H67.1971V108.874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.804 305.079H51.9805V357.029H65.804V305.079Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5107 318.233H65.8086V347.33H76.5107V318.233Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4027 373.082H34.1484V384.453H77.4027V373.082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3971 359.687H66.9141V373.081H77.3971V359.687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6978 392.033H47.9648V405.634H68.6978V392.033Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5722 417.814H46.7656V433.621H62.5722V417.814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9145 417.814H62.5664V428.377H66.9145V417.814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3971 417.005H66.9141V441.976H77.3971V417.005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.205 417.814H88.5508V438.856H118.205V417.814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.097 414.328H102.812V417.812H113.097V414.328Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0333 259.205H52.6523V301.177H67.0333V259.205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6545 273.147H33.9258V287.517H52.6545V273.147Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3473 231.445H48.3008V259.873H62.3473V231.445Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6545 254.689H33.9258V264.054H52.6545V254.689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4939 227.099H33.9258V237.634H54.4939V227.099Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9558 199.507H35.0898V223.419H44.9558V199.507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1282 202.697H53.7109V223.921H90.1282V202.697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4704 239.975H71.043V256.195H99.4704V239.975Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.645 219.685H85.2578V232.365H101.645V219.685Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.4 140.312H157.828V176.598H179.4V140.312Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.201 162.289L380 149.574L344.902 194.292L361.103 207.008L396.201 162.289Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.323 203.591L420.59 193.598L391.754 230.338L404.486 240.332L433.323 203.591Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.47711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.693 469.734H-20.6797V562.04H568.693V469.734Z",
    fill: "#6C3950"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_15475"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 491.383,
    height: 480.629,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopSm);
export default __webpack_public_path__ + "static/media/desktop-sm.f4d2ac5c51945544574b980275d2f110.svg";
export { ForwardRef as ReactComponent };